var isUserActive = false;
var activityTimeout;
var activityTimer;

/** 设置判断时间 默认五分钟 */
var constructor = (timeout = 1000 * 60 * 5) => {
  activityTimeout = timeout;
  initialize();
}

/** 初始化 */
var initialize = () => {
  // 监听用户的各种事件，例如鼠标移动、键盘输入等
  window.addEventListener("mousemove", handleUserActivity);
  window.addEventListener("click", handleUserActivity);
  window.addEventListener("scroll", handleUserActivity);
  window.addEventListener("keydown", handleUserActivity);

  // 设置定时器检测用户是否处于活动状态
  startActivityTimer();
}

var handleUserActivity = () => {
  isUserActive = true;
  restartActivityTimer();
}

var startActivityTimer = () => {
  activityTimer = setTimeout(() => {
    isUserActive = false;
  }, activityTimeout);
}

var restartActivityTimer = () => {
  if (activityTimer) {
    clearTimeout(activityTimer);
  }
  startActivityTimer();
}

/** 获取状态 */
var active = () => {
  return isUserActive;
}

/** 销毁 */
var destroy = () => {
  window.removeEventListener("mousemove", handleUserActivity);
  window.removeEventListener("keydown", handleUserActivity);

  if (activityTimer) {
    clearTimeout(activityTimer);
  }
}

export {
  constructor,
  active,
  destroy
}